var userControls =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.l = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };

/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};

/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};

/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 11);
/******/ })
/************************************************************************/
/******/ ({

/***/ 11:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(2);
module.exports = __webpack_require__(7);


/***/ }),

/***/ 2:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 7:
/***/ (function(module, exports) {

/**
 * jQuery plugin to wrap a custom jQueryUI accordion for use in the VIL
 * Holds the dst, as well as additional app specific panels if needed
 * Also manages the vertical expand-collapse 'accordion handler'
 * 
 */

(function($)
{
    $.fn.customaccordion = function(vilInstance)
    {
        var self = this;

        var vil = vilInstance;

        if (vil == null || typeof vil == "undefined")
        {
            $.error("VIL instance cannot be null");
        }

        var settings = vil.getConfiguration();

        var resizeOnce = false;

        var accordionOptions = {
            heightStyle: "content",
            animate: 150
        };

        /**
         * Viewmodel bound to the vertical 'accordion handler'
         * @returns {undefined}
         */
        var handlerViewModel = function() {
            var me = this;
            me.isStale = ko.observable(false); // this is used to force re-eval of he summaryTitle computed
            me.toggle = function()
            {
                self.collapseTray(!settings.accordionSettings.collapsed);
            };
            // TODO: can't use ko.computed here, because eSM still uses older version of Knockout)
            me.summaryTitle = ko.dependentObservable(function() {
                if (me.isStale() === true) {
                    me.isStale(false);
                }
                var result = "";
                if (settings.accordionSettings && settings.accordionSettings.displayHandlerTitle) {
                    var dst = vil.getDst();
                    if (dst) {
                        result = dst.summaryTitleWithSlideCount();
                    }
                }
                return result;
            }, me, {deferEvaluaton: true}); // dst not avail yet so we can't init this here
        };

        self.refreshSummary = function() {
            self.vm.isStale(true);
        };

        self.vm = new handlerViewModel();

        self.isInitialized = function()
        {
            if (settings)
                return true;

            return false;
        };


        /**
         * Brings the slide tray into the accordion
         * Looks for 'import' div - if present, loads dst into it; otherwise, appends dst div to accordion
         * TODO: Why is this here? Accordion widget should not have internal knowledge of external objects like VIL or DST -ccb
         * @returns {undefined}
         */
        self.importElements = function()
        {
            var accordion = vil.find("#" + settings.accordionSettings.divId);

            if (accordion.length == 1)
            {
                // Check if the import div is present in the view html (this will be the case for PR, for example)
                var dstImport = accordion.find('#' + settings.accordionSettings.divImportDst);
                if (dstImport.length == 0)
                {
                    if ('undefined' !== typeof window.__isAIH && true === window.__isAIH) {
                        accordion.append("<h3>" + settings.dstSettings.dstTitle + "</h3>");
                    }
                    accordion.append("<div id='" + settings.dstSettings.divId + "' class='dst_container'></div>");
                }
                else
                {
                    dstImport.append("<div id='" + settings.dstSettings.divId + "' class='dst_container'></div>");
                }
                self.refresh();
            }
        };

        /**
         * Append array of panels to accordion HTML
         * Array of panels in the form: [{id: '', title: 'title', html: '...', cssClass: 'class' }]
         * @returns {undefined}
         */
        self.appendPanels = function(panels)
        {
            var accordionDiv = vil.find("#" + settings.accordionSettings.divId);
            $.each(panels, function(index, panel) {
                accordionDiv
                        .append($("<h3>").addClass(panel.cssClass).text(panel.title))
                        .append($("<div>").attr('id', panel.id).addClass(panel.cssClass).html(panel.html));
            });
            self.refresh(); // rebuild the jQuery UI accordion 
        };

        /**
         * Rebuild the jQuery UI accordion based on the underlying HTML.
         * @returns {undefined}
         */
        self.refresh = function() {
            // TODO: in jqueryui 1.10, .accordion('refresh') is suffcient to redraw after adding panels - no destroy needed
            var accordionDiv = vil.find("#" + settings.accordionSettings.divId);
            if (accordionDiv.length > 0) {
                if (accordionDiv.is(':ui-accordion'))
                {
                    accordionDiv.accordion("destroy");
                    accordionDiv.accordion(accordionOptions);                
                }            
            }
            // This is needed for case of popup with DST embedded in surrounding accordionContainer
            var accordionDiv = vil.find(".dst_accordion");
            if (accordionDiv.length > 0) {
                if (accordionDiv.is(':ui-accordion'))
                {
                    accordionDiv.accordion("refresh");           
                }            
            }            
        };

        /**
         * Attach the needed elements to the accordion markup, then call initialize, which transforms it into jqueryUI widget
         * @returns {undefined}
         */
        self.renderAccordion = function()
        {
            var accordion = vil.find("#" + settings.accordionSettings.divId);
            if (accordion.length == 0)
            {
                if (settings.accordionSettings.divImport != null)
                {
                    var importDivContent = $('#' + settings.accordionSettings.divImport);
                    if (importDivContent.length == 0)
                    {
                        //arizzini we don't have an import div.
                        var accordionAlreadyExists = $("#" + settings.accordionSettings.divId);
                        if (accordionAlreadyExists.length == 0)
                        {
                            vil.append("<div id='" + settings.accordionSettings.divId + "' class='dstaccordion' style='width: 401px;' ></div>");
                        }
                        else
                        {
                            accordionAlreadyExists.css("width", 401);
                            accordionAlreadyExists.appendTo(vil);
                        }
                    }
                    else
                    {
                        // arizzini we have an import div.
                        vil.append("<div id='" + settings.accordionSettings.divId + "' style='width: 401px;' ></div>");

                        if (accordionAlreadyExists.length != 0)
                        {
                            accordionAlreadyExists.appendTo(vil);
                        }
                    }
                }
                else
                {
                    vil.append("<div id='" + settings.accordionSettings.divId + "' style='width: auto;' ></div>");
                }
            }
            self.initializeAccordion();
        };

        /**
         * Append the markup needed for the vertical collapse-expand bar and bind view model
         * @returns {undefined}
         */
        self.renderAccordionHandler = function()
        {
            var accordion = vil.find("#" + settings.accordionSettings.divHandlerId);
            if (accordion.length == 0)
            {
                vil.append("<div id='" + settings.accordionSettings.divHandlerId + "' class='accordion_tray-handle'  data-bind='click: toggle'>"
                        + "     <div id='accordionHandlerImage' class='collapseIcon accordionHandlerImage'></div> "
                        + " 	<span id='accordionHandlerTitle' class='accordionHandlerTitle' data-bind='text: summaryTitle'  >" + "</span>"
                        + "</div>");

                $.each(vil.find('.accordion_tray-handle'), function()
                {
                    ko.applyBindings(self.vm, this);
                });

            }
        };

        self.collapseTray = function(doCollapse)
        {
            if (!settings.displayViewer)
            {
                return;
            }

            settings.accordionSettings.collapsed = doCollapse;

            var accordion = vil.find("#" + settings.accordionSettings.divId);

            var handler = vil.find("#accordionHandlerImage");

            if (doCollapse)
            {
                handler.toggleClass('collapseIcon expandIcon');
                accordion.hide();

            }
            else
            {
                handler.toggleClass('expandIcon collapseIcon');
                accordion.show();

            }

            // Move the dst and uScope to the right or left
            //accordion.css('left', dstX);
            //uScope.css("left", uScopeX);
            vil.resize('Resize');
        };

        /**
         * Given an accordion panel index, make it the active one
         * @param {type} activeIndex
         * @returns {undefined}
         */
        self.activatePanel = function(activeIndex) {
            if (settings.accordionSettings.divId != null) {
                vil.find("#" + settings.accordionSettings.divId).accordion({active: activeIndex});
            } else {
                vil.find(".dst_accordion").accordion({active: activeIndex});
            }
        };

        /**
         * Transform the accordion markup into a JQueryUI accordion widget
         * @returns {undefined}
         */
        self.initializeAccordion = function()
        {
      
            if (settings.accordionSettings.divImport != null || (typeof window.__isAIH != 'undefined' && window.__isAIH))
            {
                var accordionDiv = vil.find("#" + settings.accordionSettings.divId);
                if (accordionDiv.is(':ui-accordion'))
                {
                    accordionDiv.accordion("destroy");
                }

                accordionDiv.accordion(accordionOptions);

            }
            else
            {
                var accordionDiv = vil.find(".dst_accordion");
                if (accordionDiv.is(':ui-accordion'))
                {
                    accordionDiv.accordion("destroy");
                }

                accordionDiv.accordion(
                        {
                            event: "click hoverintent",
                            autoHeight: true
                        });
            }
        };

        /**
         * Adjust the height of the vertical collapse-expand accordion 'handler'
         * @returns {undefined}
         */
        self.setAccordionHandlerHeight = function()
        {
            var accordion = vil.find("#" + settings.accordionSettings.divHandlerId);

            if (accordion.length != 0)
            {
                var uscope = vil.find("#" + settings.uScope.setup.divId);

                if (uscope.length != 0)
                {
                    accordion.height(uscope.height());
                }
            }
        };

        // Attach jQuery Object Prototype (fn function)
        return self;

    };

})(jQuery);






/***/ })

/******/ });